import { useEffect } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { useArmRecordingMobileLock } from '../../model/useArmRecordingMobileLock';
import { useRecordingMobileLockModalStore } from '../../model/useRecordingMobileLockModalStore';
import { RecordingMobileLockModal } from './RecordingMobileLockModal';

export const RecordingMobileLockModalMount = () => {
  useArmRecordingMobileLock();
  const isOpen = useRecordingMobileLockModalStore((s) => s.isOpen);

  useEffect(() => {
    if (isOpen) MixpanelEvents.desktopRequiredStateShown();
  }, [isOpen]);

  return <RecordingMobileLockModal />;
};
